import * as moment from 'moment-timezone';
/**
 * Handling response for chart
 * @method quoteFeedCallBack
 * @param {any} cb
 * @param {any} results
 * @param {boolean} eod
 * @param {string} timeZone
 * @param {string} exchange
 */
export function quoteFeedCallBack(cb, results, eod, timeZone, exchange) {
    if (exchange === void 0) { exchange = 'IDMS'; }
    try {
        cb({
            quotes: cloneResults(results, eod, timeZone),
            moreAvailable: false,
            attribution: { source: 'IDMS', exchange: exchange },
        });
    }
    catch (err) {
        console.error(err);
        cb({
            quotes: [],
            moreAvailable: false,
            attribution: { source: 'IDMS', exchange: exchange },
        });
    }
}
/**
 * Clones the passed array into a new one without using the same references
 *
 * @param {Array} results
 * @param {boolean} eod
 * @param {string} timeZone
 * @returns {Array} array
 */
export function cloneResults(results, eod, timeZone) {
    var clonedResults = [];
    if (results) {
        results.forEach(function (result) {
            if (result && result.length <= 6) {
                clonedResults.push(cloneResult(result, eod, timeZone));
            }
        });
    }
    return clonedResults;
}
/**
 * Create record for chart
 *
 * @param {any} result
 * @param {boolean} eod
 * @param {string} timeZone
 * @returns {any} {Open: any, High: any, Low: any, Close: any, Volume: number, Date: any}}
 */
export function cloneResult(result, eod, timeZone) {
    var volume = 0;
    if (result.length === 6) {
        volume = result[5];
    }
    var date2Use = result[0];
    if (!date2Use) {
        throw Error('Invalid data, no date provided');
    }
    var timezone2Use = eod ? 'UTC' : timeZone;
    var momentDate = moment.tz(date2Use * 1000, timezone2Use);
    if (!momentDate.isValid()) {
        throw Error('Invalid data, date not valid');
    }
    var dateFormat = eod ? 'YYYYMMDD' : 'YYYYMMDDHHmmssmmm';
    var dateStr = momentDate.format(dateFormat);
    if (result.length < 5) {
        return {
            Open: null,
            High: null,
            Low: null,
            Close: null,
            Volume: null,
            Date: dateStr,
        };
    }
    else {
        return {
            Open: Number(result[1]),
            High: Number(result[2]),
            Low: Number(result[3]),
            Close: Number(result[4]),
            Volume: Number(volume),
            Date: dateStr,
        };
    }
}
/**
 * Helper method to cope with locales although we do not have locales in pt
 *
 * @param {string} language
 * @returns {string}
 */
export function getLocale(language) {
    switch (language) {
        case 'de':
            return 'de-DE';
        case 'en':
            return 'en-US';
        case 'es':
            return 'es-ES';
        case 'fr':
            return 'fr-FR';
        case 'it':
            return 'it-IT';
        case 'fi':
            return 'en-US';
        case 'sv':
            return 'en-US';
        case 'nw':
            return 'en-US';
        case 'dk':
            return 'en-US';
        default:
            return language;
    }
}
/**
 * Parses the input parameters and returns and object with the ones to be used
 *
 * @param {any} symbol
 * @param {any} startDate
 * @param {any} endDate
 * @param {any} params
 * @param {any} priceType
 * @param {any} withEarnings
 * @returns {any}
 */
export function parseParameters(symbol, startDate, endDate, params, priceType, withEarnings) {
    var resultParams = {
        idNotation: null,
        priceType: priceType,
        withEarnings: withEarnings,
        rangeType: null,
        origin: {
            symbol: symbol,
            startDate: startDate,
            endDate: endDate,
            params: params,
        },
    };
    parseSymbol(symbol, resultParams);
    /**
     * Only eod and intraday are supported for now
     * @type {string}
     */
    resultParams.rangeType = 'eod';
    if ('minute' === params.interval) {
        resultParams.rangeType = 'intraday';
    }
    return resultParams;
}
/**
 * Extracts the idNotation, priceType, earnings from the symbol
 *
 * @param {string} symbol
 * @param {any} resultParams
 */
export function parseSymbol(symbol, resultParams) {
    /**
     * trick for chart IQ convenience
     */
    if (symbol.indexOf('#') !== -1) {
        var info = symbol.split('#');
        if (info && info.length === 3) {
            resultParams.idNotation = Number(info[0]);
            //resultParams.priceType = info[1];
            resultParams.withEarnings = Number(info[2]);
        }
    }
    else {
        resultParams.idNotation = Number(symbol);
    }
}
/**
 * Maps the passed moment timezone to the chartIQ one
 *
 * @method mapTZ2ChartIQTZ
 * @param {any} timezoneMap
 * @param {string} timezone
 * @returns {string}
 */
export function mapTZ2ChartIQTZ(timezoneMap, timezone) {
    var offset = moment.tz(timezone).utcOffset();
    var symbol = '+', addZero = '', offSetString = Math.abs(offset) / 60 + '', offsetArray = offSetString.split('.'), offsetHours = Number(offsetArray[0]), offsetMinutes = '00';
    if (offsetArray.length > 1) {
        offsetMinutes = (Number(offsetArray[1]) * 6).toString();
    }
    if (Math.abs(offsetHours) < 10) {
        addZero = '0';
    }
    if (offset <= 0) {
        symbol = '-';
    }
    var offsetInHoursAsStringFormatted = symbol + addZero + offsetHours + ':' + offsetMinutes;
    if (offset === 0) {
        offsetInHoursAsStringFormatted = '(UTC)';
    }
    var foundKey = Object.keys(timezoneMap).find(function (key) {
        return key.indexOf(offsetInHoursAsStringFormatted) !== -1;
    });
    return timezoneMap[foundKey];
}
/**
 * @method resultsContainTodayOHLC
 * @param {any} results
 * @returns {boolean}
 */
export function resultsContainTodayOHLC(results) {
    return Date.now() - results[results.length - 1][0] * 1000 >= 86400000;
}
//# sourceMappingURL=parse.js.map